import { type FC } from "react";
import { getFilenameInfo } from "widgets/utils";

import type { EventResource } from "@/graphql.ts";
import { FilesStackTile } from "@/modules/files/components/FilesStackTile.tsx";
import { FileTile } from "@/modules/files/components/FileTile";
import { EVENT_RESOURCE_TYPES } from "@/settings/settings.ts";
import { PlaybookEventResource } from "@/ui-modules/playbooks/events/PlaybookEventResource.tsx";

export interface CategorizedResources {
  category: string;
  resources: EventResource[];
}

/**
 * Listing of Playbooks files.
 * Do not stack if we have a `single` category
 */
export const PlaybookEventResources: FC<{
  categorizedResources: CategorizedResources;
  single?: boolean;
  isExpanded?: boolean;
}> = (props) => {
  const { resources, category } = props.categorizedResources;

  if (resources.length > 1 && props.single !== true && props.isExpanded !== true) {
    const files = resources
      .map((resource) => resource.file)
      .filter((f) => f != null)
      .sort((r, l) => {
        const fa = getFilenameInfo(r.fileName);
        const fb = getFilenameInfo(l.fileName);
        const a = fa?.extension;
        const b = fb?.extension;
        if (!a && !b) return 0;
        if (!a) {
          return -1;
        }
        if (!b) {
          return +1;
        }
        return a.localeCompare(b);
      });

    if (files.length == 1) {
      return <FileTile file={files[0]} />;
    } else if (files.length > 0) {
      const firstResourceType = resources[0].resourceType;
      const resourceType = firstResourceType === EVENT_RESOURCE_TYPES.UNKNOWN ? category : firstResourceType;

      return <FilesStackTile files={files} type={resourceType} />;
    }
  }

  return (
    <>
      {resources.map((resource, index) => (
        <PlaybookEventResource key={`resource-${index}`} eventResource={resource} resourceCategory={category} />
      ))}
    </>
  );
};
